var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatistics = function SvgStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 31.869 31.869",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.741h7.942V20.543a2.728 2.728 0 0 0-2.728-2.728H2.727A2.73 2.73 0 0 0 0 20.543v11.198zM11.966 31.741h7.942V12.085a2.728 2.728 0 0 0-2.727-2.728h-2.49a2.728 2.728 0 0 0-2.728 2.728l.003 19.656zM26.656.127a2.729 2.729 0 0 0-2.729 2.728v28.887h7.942V2.854A2.73 2.73 0 0 0 29.14.126l-2.484.001z"
  })));
};
export default SvgStatistics;